import React from "react";
import {Scoodle2FAFailed} from "../../../components/05pages/scoodle/Scoodle2FA/Scoodle2FAFailed";

export const Scoodle2FAFailedPage : React.FC = props => {
    return <Scoodle2FAFailed
        onRetry={() => window.location.href = "/Scoodle2FA/Retry" } />
}